"use client";

import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../layouts/ThemeProvider";

/**
 * Crystal dark / light switch. Toggles the `light` / `dark` class on
 * <html> via the crystal ThemeProvider (persisted to localStorage). The
 * crystal palette is dark by default; the `.light .theme-crystal` block
 * in styles/variables.css supplies the "Crystal Day" light palette.
 */
export function CrystalThemeToggle({
  currentLanguage = "en",
}: {
  currentLanguage?: "en" | "mm";
}) {
  const { actualTheme, setTheme } = useTheme();
  const isLight = actualTheme === "light";
  const label = isLight
    ? currentLanguage === "mm"
      ? "အမှောင်သို့"
      : "Switch to dark"
    : currentLanguage === "mm"
      ? "အလင်းသို့"
      : "Switch to light";

  return (
    <button
      type="button"
      className="crystal-theme-toggle"
      onClick={() => setTheme(isLight ? "dark" : "light")}
      aria-label={label}
      title={label}
    >
      {isLight ? <Moon className="h-[18px] w-[18px]" /> : <Sun className="h-[18px] w-[18px]" />}
    </button>
  );
}

export default CrystalThemeToggle;
